import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Menu.js
// module id = 4801
// module chunks = 2